module.exports = __webpack_public_path__ + "static/media/01_MLPS-1.5-S-12.0-0 1.6f4bf071.png";